import { createWebHistory , createRouter } from 'vue-router'
export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/index.vue')
  },
  {
    path: '/products',
    component: ()=> import('@/views/products/index.vue')
  },
  {
    path: '/recruitment',
    name:'recruitment',
    component: ()=> import('@/views/products/components/recruitment.vue')
  },
  {
    path: '/qixun',
    name:'qixun',
    component: ()=> import('@/views/products/components/qixun.vue')
  },
  {
    path: '/gongyingshang',
    name:'gongyingshang',
    component: ()=> import('@/views/products/components/gongyingshang.vue')
  },
  {
    path: '/zhuanjiaku',
    name:'zhuanjiaku',
    component: ()=> import('@/views/products/components/zhuanjiaku.vue')
  },
  {
    path: '/shangcheng',
    name:'shangcheng',
    component: ()=> import('@/views/products/components/shangcheng.vue')
  },
  {
    path: '/signed',
    name:'signed',
    component: ()=> import('@/views/products/components/signed.vue')
  },
  {
    path: '/debenture',
    name:'debenture',
    component: ()=> import('@/views/products/components/debenture.vue')
  },
  {
    path: '/academy',
    name:'academy',
    component: ()=> import('@/views/products/components/academy.vue')
  },
  {
    path: '/conferenceManagement',
    name:'conferenceManagement',
    component: ()=>import('@/views/products/components/conferenceManagement.vue')
  },
  {
    path: '/blockchain',
    name:'blockchain',
    component: ()=> import('@/views/products/components/blockchain.vue')
  },
  {
    path: '/business',
    component: ()=> import('@/views/business/index.vue')
  },
  {
    path: '/audit',
    component: ()=> import('@/views/business/components/audit.vue')
  },
  {
    path: '/shuzihua',
    component: ()=> import('@/views/business/components/shuzihua.vue')
  },
  {
    path: '/shujuyaosu',
    component: ()=> import('@/views/business/components/shujuyaosu.vue')
  },
  {
    path: '/training',
    component: ()=> import('@/views/business/components/training.vue')
  },
  {
    path: '/member',
    component: ()=> import('@/views/business/components/member.vue')
  },
  {
    path: '/ebs',
    component: ()=> import('@/views/business/components/ebs.vue')
  },
  {
    path: '/soft',
    component: ()=> import('@/views/business/components/soft.vue')
  },
  {
    path: '/internet',
    component: ()=> import('@/views/business/components/internet.vue')
  },
  {
    path: '/software',
    component: ()=> import('@/views/business/components/software.vue')
  },
  {
    path: '/icp',
    component: ()=> import('@/views/business/components/icp.vue')
  },
  {
    path: '/partners',
    component: () => import('@/views/partners/index.vue')
  },
  {
    path: '/news',
    component: () => import('@/views/news/index.vue')
  },
  {
    path: '/aboutus',
    component:  () => import('@/views/aboutus/index.vue')
  },
  {
    path: '/dangjian',
    component:  () => import('@/views/dangjian/index.vue')
  }, {
    path: '/box',
    component:  () => import('@/views/box/box.vue')
  },
  {
    path: '/login/:id?',
    name: 'login',
    component:  () => import('@/views/login.vue')
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: "/news/:id",
    name: 'news',
    component: () => import('@/views/news/newsDefinePage.vue')
  }
]
const router = createRouter({
  history: createWebHistory (),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});

export default router;